// extracted by mini-css-extract-plugin
var _1 = "RentalPortalApplicantProfileWidgetMatchedListing-modulecontent__JDiuE WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "RentalPortalApplicantProfileWidgetMatchedListing-modulefacts___2F7b";
var _3 = "RentalPortalApplicantProfileWidgetMatchedListing-moduleopenButton__WPLcO";
var _4 = "RentalPortalApplicantProfileWidgetMatchedListing-moduleunit__ngXe5";
var _5 = "RentalPortalApplicantProfileWidgetMatchedListing-moduleunitIcon__thW6x";
var _6 = "RentalPortalApplicantProfileWidgetMatchedListing-moduleunitRow__EfAxQ";
export { _1 as "content", _2 as "facts", _3 as "openButton", _4 as "unit", _5 as "unitIcon", _6 as "unitRow" }
